import { set, remove, get } from 'js-cookie';
import cookies from 'next-cookies';

import EXPIRES_COOKIES from '../../libs/cookies';

import { setCustomerCep, setCartId } from './cookies';

/**
 * Busca os cookies do customer do lado do servidor.
 *
 * @param {Object} ctx ctx do next pages.
 *
 * @returns {Object} retorna um objeto com id, token, name e cartId do customer.
 */
export function getServerUser(ctx) {
  const id = cookies(ctx)['customer.id'] || null;
  const idCustomer = cookies(ctx)['customer.id'] || null;
  const cartId = cookies(ctx)['cart.id'] || null;
  const token = cookies(ctx)['customer.token'] || null;
  const nickName = cookies(ctx)['customer.nickName'] || null;
  const smartPid = cookies(ctx).SMART_PID || null;

  return { id, idCustomer, token, nickName, cartId, smartPid };
}

/**
 * Salva o id, nome e o token do usuário nos cookies , com os nomes 'customer.id',
 * 'customer.nickName' e 'customer.token' respectivamente. Além do carrinho e cep.
 *
 * @param {Object} user objeto com as propriedade id, name, cartId, cepDefault, e token.
 */
export function signInUser({ id, name, cartId, cepDefault, token, domain }) {
  if (global.window) {
    if (id) {
      set('customer.id', id, {
        expires: EXPIRES_COOKIES,
        domain,
        path: '/',
      });
    }

    if (name) {
      set('customer.nickName', name, {
        expires: EXPIRES_COOKIES,
        domain,
        path: '/',
      });
    }

    if (token) {
      set('customer.token', token, {
        expires: EXPIRES_COOKIES,
        domain,
        path: '/',
      });
    }

    if (cartId) setCartId(cartId, domain);

    if (cepDefault) setCustomerCep(cepDefault, domain);
  }

  return null;
}

/**
 * Busca o id do usuário nos cookies ou no local storage.
 *
 * @returns {String} id do usuário ou null caso não encontre.
 */
export function getUserId() {
  if (global.window) {
    const userId = get('customer.id') || null;

    return userId;
  }

  return null;
}

/**
 * Busca as informações do usuário salvas nos cookies e local storage.
 *
 * @returns {Object} retorna um objeto com as informações do usuário { id, nickName, token }.
 */
export function getUserInfo() {
  if (global.window) {
    const id = get('customer.id') || null;

    const nickName = get('customer.nickName') || null;

    const token = get('customer.token') || null;

    const user = {};

    if (id) user.id = id;
    if (nickName) user.nickName = nickName;
    if (token) user.token = token;

    return user;
  }

  return {};
}

export function removeAllCookies(domain) {
  const COOKIES_WHITE_LIST = ['SMART_ACCEPT_COOKIES_POLICY', 'SMART_SHOW_COOKIES_POLICY'];

  Object.keys(get()).forEach(function removes(cookieName) {
    const attributtes = {
      domain,
      path: '/',
    };

    if (!COOKIES_WHITE_LIST.includes(cookieName)) {
      remove(cookieName, attributtes);
    }
  });
}

/**
 * Remove os id do usuário dos cookies e local storage, não recebe nenhum parâmetro.
 */
export function signOutUser(nextPath, domain) {
  if (global.window) {
    removeAllCookies(domain);
    if (nextPath) {
      window.location.assign(nextPath);
    } else {
      return window.location.reload(true);
    }
  }

  return null;
}
